import React from 'react';
import { Trophy } from 'lucide-react';
export const SystemIntro = () => {
  return <section className="py-20 bg-brand-900 text-white text-center" data-id="element-246">
      <div className="max-w-4xl mx-auto px-4" data-id="element-247">
        <div className="inline-flex items-center justify-center p-4 bg-brand-800 rounded-full mb-8" data-id="element-248">
          <Trophy className="w-12 h-12 text-amber-400" data-id="element-249" />
        </div>
        <h2 className="text-3xl md:text-5xl font-extrabold mb-6 leading-tight" data-id="element-250">
          🏆 El Sistema N°1 para Profesores de Patín Artístico Argentinos
        </h2>
        <h3 className="text-2xl md:text-3xl font-bold text-brand-200 mb-8" data-id="element-251">
          PATÍN 360 — Colección Completa
        </h3>
        <p className="text-xl text-brand-100 mb-12 font-medium" data-id="element-252">
          12 Tomos + 6 Bonus + 2 Élite — Todo resuelto, todos los niveles.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-253">
          <div className="bg-brand-800/50 p-6 rounded-2xl border border-brand-700" data-id="element-254">
            <div className="text-3xl font-bold text-white mb-2" data-id="element-255">+280</div>
            <div className="text-brand-200 text-sm uppercase tracking-wider font-semibold" data-id="element-256">
              páginas
            </div>
          </div>
          <div className="bg-brand-800/50 p-6 rounded-2xl border border-brand-700" data-id="element-257">
            <div className="text-3xl font-bold text-white mb-2" data-id="element-258">+120</div>
            <div className="text-brand-200 text-sm uppercase tracking-wider font-semibold" data-id="element-259">
              ejercicios graficados
            </div>
          </div>
          <div className="bg-brand-800/50 p-6 rounded-2xl border border-brand-700" data-id="element-260">
            <div className="text-xl font-bold text-white mb-2 leading-tight" data-id="element-261">
              Niños y<br data-id="element-262" />
              Adultos
            </div>
          </div>
          <div className="bg-brand-800/50 p-6 rounded-2xl border border-brand-700" data-id="element-263">
            <div className="text-xl font-bold text-white mb-2 leading-tight" data-id="element-264">
              Inicial, Intermedio
              <br data-id="element-265" />y Avanzado
            </div>
          </div>
        </div>
      </div>
    </section>;
};